import { CustomGridPageBase } from "../../common/custom-grid-page.base";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { InspectorsConstants } from "../../../../models/tasks/task.model";
import { HistoryHelper } from "../../../../helpers/history-helper";
import {BindingEngine} from "aurelia-framework";

export abstract class BaseInspectorTab extends CustomGridPageBase
{
    public getItemRoute: (id: number) => string;

    constructor(i18N: I18N, protected router: Router, protected bindingEngine: BindingEngine) {
        super(i18N, 'Inspectors', bindingEngine);
    }

    public itemClick() {
        HistoryHelper.addState(InspectorsConstants.historyInspectorsTabKey, this.itemsName);
        return true;
    }

    activate()
    {
        this.clearAllFilters(false);
        this.setDefaultFilters();
        this.onActivated();
    }

    public onActivated()
    {}

    protected abstract setDefaultFilters(): void;
    protected abstract clearAllFilters(reload: boolean): void;
}